<template>
  <fin-dialog
    v-model="dialog"
    :max-width="dialogWidth"
    content-class="fin-confirm-dialog"
    persistent
    @input="(val) => {if (val === false){dialog = false}}"
  >
    <template #title v-if="options.title">
      <fin-lexicon-text auto-solve :text="options.title" v-if="options.titleWithLexikonLink"/>
      <span v-else>{{ options.title }}</span>
    </template>
    <div class="fin-confirm-dialog-content">
      <v-card-text v-for="(text, index) in options.texts" :key="index">
        <p class="fin-confirm-dialog-content__text" :style="text.style ? text.style : ''">
          <fin-lexicon-text auto-solve :text="text.content" v-if="options.textWithLexikonLink"/>
          <span v-else>{{ text.content }}</span>
        </p>
      </v-card-text>
    </div>
  </fin-dialog>
</template>

<script>
import {EventBus} from '@/plugins/fincraft'
import FinLexiconText from '@/components/common/lexicon/LexiconText/index'

export default {
  name: 'fin-alert',
  components: {FinLexiconText},
  data() {
    return {
      dialog: false,
      dialogWidth: 780,
      options: {},
    }
  },
  methods: {
    alert(obj) {
      this.options = Object.assign(obj.options)
      this.dialog = true
      this.dialogWidth = this.options.dialogWidth ? this.options.dialogWidth : this.dialogWidth
    },
  },
  mounted() {
    EventBus.$on('alert', this.alert)
  },
  beforeDestroy() {
    EventBus.$off('alert', this.alert)
  }
}
</script>

<style lang="scss" scoped>
@import "./../../../styles/variables.scss";

.fin-confirm-dialog-content__text {
  font-size: 1em;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.4;
  letter-spacing: normal;
}

.fin-confirm-dialog-content__text {
  margin-bottom: 18px;
}

.fin-confirm-dialog-content__text-field {
  margin-bottom: 24px;
}

::v-deep .v-text-field__details {
  display: none !important;
}

::v-deep .v-card__text {
  padding: 0 !important;
}

</style>
